import { render, staticRenderFns } from "./changeLanguage.vue?vue&type=template&id=b713d1a8&scoped=true"
import script from "./changeLanguage.vue?vue&type=script&lang=js"
export * from "./changeLanguage.vue?vue&type=script&lang=js"
import style0 from "./changeLanguage.vue?vue&type=style&index=0&id=b713d1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b713d1a8",
  null
  
)

export default component.exports